import { Component, Input } from '@angular/core';
import { SystemColorContainerType } from '@models/system-color';

@Component({
    selector: 'app-system-color-container',
    templateUrl: './system-color-container.component.html',
    styleUrls: ['./system-color-container.component.css'],
    standalone: false,
})
export class SystemColorContainerComponent {
    @Input() data!: SystemColorContainerType;
    @Input() canEditVessel: boolean;
}
